"use client";

import dynamic from "next/dynamic";
import type { QuoteCarouselBlock } from "@mw/shared/payload-types";

const BlockQuoteCarousel = dynamic(() => import("./BlockQuoteCarousel").then(mod => mod.BlockQuoteCarousel));
const BlockQuoteCarouselMinimal = dynamic(() =>
  import("./BlockQuoteCarouselMinimal").then(mod => mod.BlockQuoteCarouselMinimal),
);

type Props = QuoteCarouselBlock & { logoStyle?: React.CSSProperties };

export const BlockQuoteCarouselLazy = ({ logoStyle, ...props }: Props) => {
  if (props.layout === "minimal") {
    return <BlockQuoteCarouselMinimal {...props} />;
  }

  return <BlockQuoteCarousel {...props} logoStyle={logoStyle ?? {}} />;
};
